var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"index-tools content"},[_c('titleMain',{attrs:{"en":"Tools","jp":"ツール一覧","tag":"h2"}}),_c('ToolsList',{staticClass:"content__item"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }